import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import { APPLY_API_URL } from "../config/env";
import { ApplicantInfo } from "../models/Applicant";

const API_URL = `${APPLY_API_URL}/applicant`;

class ApplicantService {
    private apiClient: AxiosInstance;

    constructor() {
        this.apiClient = new ApiClient(API_URL).getClient();
    }

    public getApplicant = async (): Promise<ApplicantInfo> => {
        const res = await this.apiClient.get<ApplicantInfo>("");
        return res.data;
    };

    public createUpdateApplicant = async (
        applicant: ApplicantInfo
    ): Promise<ApplicantInfo> => {
        const res = await this.apiClient.post<ApplicantInfo>("", applicant);
        return res.data;
    };
}

export default ApplicantService;